<template>

<app-view-list-field align="center" :demoted-icon="field.type" :is-sticky="isSticky" :is-demoted="isDemoted" :field="field" :filter="filter">

    <span>{{ value }}</span>

</app-view-list-field>

</template>

<script>

var LABELS = { 1: 'Must', 2: 'Love', 3: 'Like', 4: 'Maybe', 5: "Don't" }

export default {

	props: ['field', 'filter', 'item', 'isSticky', 'isDemoted'],

	computed: {

		value: function() {

			var p = this.item.user && this.item.user.wishlist && this.item.user.wishlist.priority
			return LABELS[p] || '-'

		}

	}

}

</script>
